import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { isEmpty } from 'lodash';

import useStyles from './searchInputStyles';

export const SearchInput = ({ value, onChange, externalClasses = {} }) => {
    const classes = useStyles();

    const containerClassNames = clsx({
        [classes.container]: true,
        [externalClasses.container]: !isEmpty(externalClasses.container),
    });

    useEffect(() => () => onChange(''), []);

    return (
        <div className={containerClassNames}>
            <FontAwesomeIcon
                className={classes.searchIcon}
                icon={['fas', 'search']}
                size={'xs'}
            />
            <input
                data-test-id='employer-search-input'
                placeholder={''}
                value={value}
                className={classes.input}
                onChange={(e) => onChange(e.target.value)}
            />
            { value && (
                <FontAwesomeIcon
                    className={classes.clearIcon}
                    icon='times'
                    size={'xs'}
                    data-test-id='search-value-remove-btn'
                    onFocus={(e) => e.stopPropagation()}
                    onClick={() => onChange('')}
                />
            )}
        </div>
    );
};
